var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTajikistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0V5.33h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M24 10.662H0v5.333h24v-5.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M10.613 10.085h2.782V8.9l-.563.285-.832-.84-.832.84-.555-.285v1.185zM9.014 8.697l.135.398h.413l-.338.247.128.398-.338-.248-.337.248.127-.398-.337-.247h.42l.127-.398zm.405-1.395l.128.398h.42l-.338.247.128.398-.338-.24-.337.24.127-.398-.337-.247h.412l.135-.398zm1.148-1.042l.127.397h.42l-.338.248.128.397-.337-.247-.338.247.127-.397-.337-.248h.412l.136-.397zm4.417 2.437l-.127.398h-.42l.337.247-.127.398.337-.248.338.248-.128-.398.338-.247h-.42l-.128-.398zm-.405-1.395l-.127.398h-.42l.337.247-.127.398.337-.24.338.24-.128-.398.345-.247h-.42l-.135-.398zM13.432 6.26l-.127.397h-.42l.338.248-.128.397.337-.247.338.247-.127-.397.337-.248h-.412l-.136-.397zM12 5.735l.127.405h.42l-.337.247.127.398L12 6.537l-.338.248.128-.398-.337-.247h.42L12 5.735z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajikistan);
export default __webpack_public_path__ + "static/media/Tajikistan.97dc3680b531ee9e47cfeccecead6240.svg";
export { ForwardRef as ReactComponent };